export function LegacyMark({ className = "" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M8 8.5A3.5 3.5 0 0 1 11.5 5H22v26.2L39.5 48.7V59H22A14 14 0 0 1 8 45V8.5Z" />
      <path d="M27 9.2c0-2.6 2.7-4.3 5.1-3.1l10.7 5.3a5.2 5.2 0 0 1 2.9 4.7V41H53a9 9 0 0 1 9 9v9H44v-7.9L27 34.2V9.2Z" />
    </svg>
  );
}
